export default __webpack_public_path__ + "5a4c0de829750088abed4c0a82b0e76b.png";